import bugsnag from '@bugsnag/js';

const useBugsnag = process.env.NODE_ENV === 'production' && process.env.REACT_APP_NODE_ENV !== 'dev' && process.env.REACT_APP_NODE_ENV !== 'stage';

export const bugsnagClient = useBugsnag ? bugsnag({
  apiKey: '8bfdf975aae3d3fcd446a6f683ba89a2',
  appVersion: process.env.REACT_APP_BUILD_ID || '0.1.1',
}) : null;
